<template>
	<!-- Modal: Out Of Stock -->
	<div :class="modal ? 'modal is-active' : 'modal'">
		<div class="modal-background"></div>
		<div class="modal-card is-small">
			<header class="modal-card-head">
				<button @click="closeModal()" class="delete" aria-label="close"></button>
				<p class="modal-card-title">Out of Stock</p>
			</header>
			<section class="modal-card-body has-text-centered ph20">
				<img class="has-text-centered mt15 mb20" src="@/assets/img/icon-empty.png" alt="Empty">
			  <loading v-if="loading"></loading>
        <template v-else>
          <p class="has-text-centered is-size-14 modal-text" v-if="subscribedNotification">Already subscribed, would you like to unsubscribe?</p>
          <p class="has-text-centered is-size-14 modal-text" v-else>Would you like to be notified when this<br>product is back in stock?</p>
        </template>
			</section>
			<footer class="modal-card-foot is-flex-column" v-if="!loading">
				<button @click.prevent="subscribedNotification ? cancelNotificationWhenProductAvailable() : notifyWhenProductAvailable()" class="button is-large is-primary is-full-width mr0 mb20">{{ subscribedNotification ? 'Yes, Remove Notification' : 'Yes, Notify Me' }}</button>
				<a href="#" @click.prevent="closeModal()" class="has-text-centered">No, Cancel</a>
			</footer>
		</div>
	</div>
</template>

<script>
import Env from "@/env";
import { mapGetters, mapActions } from "vuex";
import UserApis from '@/Components/Controllers/UserApis';
import { isEmpty, find } from 'lodash';

export default {
  name: 'ProductDetailDescription',
  data() {
    return {
      modal: false,
      product: {},
      loading: false,
      variant: {},
      subscribedNotification: false,
      notificationDetail: {},
    };
  },

  computed: {
    ...mapGetters({
      // selectedLocation: "location/selected"
    }),
  },

  mounted() {
    bus.$on('show-modal-out-of-stock', (payload) => {
      this.product = payload.product;
      this.variant = payload.variant;
      this.modal = payload.modal;
      this.subscribedNotification = false;
      this.notificationDetail = {};
    })
  },

  beforeDestroy() {
    bus.$off('show-modal-out-of-stock');
  },

   watch: {
    modal(val){
      if(val && !isEmpty(this.product) && !isEmpty(this.variant)) {
        this.getProductOutofStockSubscribedNotifications();
      }
    },
  },

  methods: {
   closeModal() {
     this.modal = false;
     this.product = {};
     this.variant = {};
     this.subscribedNotification = false;
     this.notificationDetail = {};
   },

  async notifyWhenProductAvailable() {
      let res = await UserApis.createOutOfstockNotification({
        location_product_id: this.variant.location_product_id, 
        user_id: this.$store.getters.getLoggedInUserId,
        status: 'subscribed',
        location_product_varaint_id: this.variant.id, 
      })
      if(res.status == 200){
         bus.$emit('refetch-outof-stock-notification', true);
        this.closeModal();
      }
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
   },
   /**
    * Cancel notification
    */

   async cancelNotificationWhenProductAvailable() {
     let res = await UserApis.removeOutOfstockNotification(this.notificationDetail.id);
      if(res.status == 200){
        this.closeModal();
        bus.$emit('refetch-outof-stock-notification', true);
      }
      this.va_snackbar({
        type: res.status == 200 ? 'success' : 'warning',
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
   },

   /**
    * Get subscribed products of this user 
    */

    async getProductOutofStockSubscribedNotifications() {
      this.loading = true;
      let res = await UserApis.listOutOfstockNotification(this.variant.location_product_id);
      let subscribed = _.find(res.data.payload, { user_id: this.$store.getters.getLoggedInUserId, location_product_id: this.variant.location_product_id, location_product_varaint_id: this.variant.id });
      if(subscribed == undefined){
        this.subscribedNotification = false;
      } else {
        this.notificationDetail = subscribed;
        this.subscribedNotification = true;
      }
      this.loading = false;
    },


    ...mapActions({
      // spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>